export default __webpack_public_path__ + "static/media/PrizeBg_mobile.4c5da240.jpg";